import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import { Languages } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface LanguageToggleProps {
  onGradientBackground?: boolean;
}

export function LanguageToggle({ onGradientBackground = false }: LanguageToggleProps) {
  const { language, setLanguage, t } = useLanguage();

  const toggleLanguage = () => {
    setLanguage(language === "en" ? "ka" : "en");
  };

  const tooltipText = language === "en" ? "ქართული" : "English";

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          size="icon"
          variant={onGradientBackground ? "ghost-utility" : "outline"}
          onClick={toggleLanguage}
          className="h-8 w-8"
          aria-label={tooltipText}
        >
          <Languages className="h-3.5 w-3.5" />
        </Button>
      </TooltipTrigger>
      <TooltipContent side="bottom" className="text-xs">
        {tooltipText}
      </TooltipContent>
    </Tooltip>
  );
}
